
import TerminalConfigService from "@/modules/PdvDesktop/services/TerminalConfigService";

export default {
  name: "BloqueioSuporte",

  data() {
    return {
      codigoBloqueio: "",
      motivoBloqueio: "Empresa bloqueada para operacoes de PDV.",
      carregando: false,
    };
  },

  async mounted() {
    await this.carregarBloqueio();
  },

  methods: {
    async carregarBloqueio() {
      if (!this.$isDesktop || !this.$electron) return;
      try {
        const [code, motivo] = await Promise.all([
          this.$electron.config.get("terminal_code_bloqueio"),
          this.$electron.config.get("terminal_motivo_bloqueio"),
        ]);
        this.codigoBloqueio = code || "";
        if (motivo) this.motivoBloqueio = motivo;
      } catch (_) {
        // Mantem fallback local
      }
    },

    async revalidarStatus() {
      if (this.carregando) return;
      this.carregando = true;
      try {
        await TerminalConfigService.garantirTerminalAutorizado({ forcar: true });
        this.$toast && this.$toast.success("Acesso liberado. Redirecionando...");
        this.$router.push({ name: "pdvDesktopDashboard" });
      } catch (e) {
        this.codigoBloqueio = e.code || this.codigoBloqueio;
        this.motivoBloqueio = e.message || this.motivoBloqueio;
        this.$toast && this.$toast.error(this.motivoBloqueio);
      } finally {
        this.carregando = false;
      }
    },

    abrirConfiguracaoTerminal() {
      this.$router.push({ name: "pdvDesktopConfiguracaoTerminal" });
    },
  },
};
